import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';

import '~/styles/index.scss';

import { Head, Modal, Snackbar } from '~/components/common';
import Confirmation from '~/components/common/Modal/Confirmation';
import { useLanguage } from '~/hooks/language';
import { useAppDispatch, useAppSelector } from '~/hooks/store';
import { resolveConfirmation } from '~/store/ux';
import { selectUX } from '~/store/ux/selectors';
import { ThemeWrapper } from '~/theme';

import Content from './Content';
import SideBar from './SideBar';

const PageLayout = () => {
  const dispatch = useAppDispatch();
  const { translate } = useLanguage('ua');
  const ux = useAppSelector(selectUX);
  const isMobile = useMediaQuery('(max-width: 600px)');

  const closeModal = React.useCallback(() => {
    void ux.confirmation?.callback(false);
    dispatch(resolveConfirmation());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ux.confirmation?.callback]);

  const approveConfirmation = React.useCallback(() => {
    void ux.confirmation?.callback(true);
    dispatch(resolveConfirmation());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ux.confirmation?.callback]);

  return (
    <ThemeWrapper>
      <Head />

      <Box display={isMobile ? 'block' : 'flex'} width="100%" height="100%">
        <SideBar />
        <Content />
      </Box>
      <Snackbar />
      <Modal open={!!ux.confirmation} onClose={closeModal}>
        <Confirmation
          confirmLabel={translate('general.continueBtnLabel')}
          cancelLabel={translate('general.cancelBtnLabel')}
          onConfirm={approveConfirmation}
          onCancel={closeModal}
        >
          <Typography variant="h5">{ux.confirmation?.title}</Typography>
        </Confirmation>
      </Modal>
    </ThemeWrapper>
  );
};

export default PageLayout;
